import { useRxData } from 'rxdb-hooks';
import { MangoQuery, RxCollection } from 'rxdb/dist/types/types';
import { useCallback, useMemo } from 'react';
import { IPrimaryDealerList } from '@components/onetoonemeetings';
import { IRxDbProps, IRxDbResponse } from '@services/hooks/enduser-details/rxdbHooks/useDealerListRxDb';

export const usePrimaryDealerListRxDb = (props: IRxDbProps): IRxDbResponse<IPrimaryDealerList> => {
	const { searchParams, sortBy } = props;

	const searchSelector = useMemo(() => {
		return searchParams.map((param) => {
			return {
				[param.key]: { $regex: `.*${param.value}.*`, $options: 'i' },
			};
		});
	}, [searchParams]);

	const queryConstructor = useCallback(
		(collection: RxCollection<IPrimaryDealerList>) => {
			let querySelector: MangoQuery<IPrimaryDealerList> = {
				selector: {
					$or: searchSelector,
				},
			};

			if (sortBy) {
				querySelector = {
					...querySelector,
					sort: [{ [sortBy]: 'asc' }],
				};
			}

			return collection.find(querySelector);
		},
		[searchSelector, sortBy]
	);

	const { result, isFetching, fetchMore } = useRxData<IPrimaryDealerList>('dealers_list', queryConstructor, {
		pageSize: 30,
		pagination: 'Infinite',
	});

	return {
		result,
		isFetching,
		fetchMore,
	};
};
